

























































import {Component, Prop, Vue} from 'vue-property-decorator'
import FormInput from '@/components/FormInput.vue'
import {FormResult} from '@/model/form-result';

@Component({
  components: {
    FormInput
  }
})
export default class Result extends Vue {
  @Prop() public result!: FormResult;
  @Prop() public hasError!: boolean;
  @Prop() public mailSendingError!: string | null;
  @Prop() public mailSendingSuccess!: string | null;
  @Prop({required: true}) public isSendingRequest!: boolean;
  public hasAgreedAGBs: boolean;

  public constructor() {
    super();
    this.hasAgreedAGBs = false;
  }

  public formatPrice(price: number) {
    return price.toFixed(2).replace('.', ',');
  }

  public get getSum() {
    return this.formatPrice((this.result.result.productPrice ? this.result.result.productPrice : 0) + (this.result.result.deliveryPrice ? this.result.result.deliveryPrice : 0));
  }

  public sendRequest() {
    if (!this.isSendingRequest) {
      this.$emit('sendRequest');
    }
  }
}
